import React, { useState } from "react";
import styles from "./DealerReporting.module.scss";
import Grid from "@mui/material/Grid";
import Item from "../../../../shared/item/Item";
import SortingIcon from "../../../../shared/sortingIcon/SortingIcon";
import SortData from "../../../../utils/SortUtil";
import { withTranslation } from "react-i18next";
import DownloadButtonV2 from "../../../../shared/buttons/DownloadButtonV2";
import { base64FileDownload } from "../../../../utils/FileDownloadUtil";
import { logMsg } from "../../../../common/Logger";
import DealerReportingClient from "../../../../shared/clients/DealerReportingClient";
import { IS_SA_MARKET } from "../../../../utils/EmpUtil";

const DealerReporting = (props) => {
  const [sortKey, setSortKey] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [reports, setReports] = useState([
    {
      key: "report6",
      name: props.t("dealerReporting.report6Name"),
      description: props.t("dealerReporting.report6Description"),
      condition: IS_SA_MARKET(props.user.market),
      downloadLink: downloadInventoryPricingHistoryReport,
    },
  ]);

  const getTodayDateDDMMYYYY = () => {
    const today = new Date();
    return `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
  };

  function downloadInventoryPricingHistoryReport(report) {
    DealerReportingClient.downloadInventoryPricingHistoryReport(
      props.user,
      props.t("dealerReporting.inventoryReportColumnHeadersForDealer")
    )
      .then((res) => {
        const filename =
          props.t(report.name) + " - " + getTodayDateDDMMYYYY() + ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
      })
      .catch((reason) => {
        logMsg("reason", reason);
      });
  }

  const sortColumns = (sortByCol) => {
    let sortDir = "DSC";
    if (sortByCol === sortKey) {
      sortDir = sortDirection === "ASC" ? "DSC" : "ASC";
    }
    SortData(
      sortByCol,
      sortDir,
      "alphanumeric",
      reports,
      function (sortedData) {
        setSortDirection(sortDir);
        setSortKey(sortByCol);
        setReports(sortedData);
      }
    );
  };

  return (
    <>
      <Grid container className={`pagePadding ${styles.gridHeader}`}>
        <Grid
          item
          md={3}
          className={styles.typeHeader}
          onClick={() => sortColumns("name")}
        >
          <Item value={props.t("dealerReporting.type")} />
          <span className={styles.sorting}>
            <SortingIcon
              currentKey="name"
              sortKey={sortKey}
              sortDirection={sortDirection}
            />
          </span>
        </Grid>
        <Grid
          item
          md={7}
          className={styles.typeHeader}
          onClick={() => sortColumns("description")}
        >
          <Item value={props.t("dealerReporting.document")} />
          <span className={styles.sorting}>
            <SortingIcon
              currentKey="description"
              sortKey={sortKey}
              sortDirection={sortDirection}
            />
          </span>
        </Grid>
        <Grid item md={2} className={styles.actionHeader}>
          <Item value={props.t("dealerReporting.action")} />
        </Grid>
      </Grid>

      {reports.map(
        (report) =>
          report.condition && (
            <React.Fragment key={report.key}>
              <Grid
                container
                className={`pagePaddingLeft pagePaddingRight ${styles.gridBody}`}
              >
                <Grid item md={3} className={styles.colType}>
                  <div>{report.name}</div>
                </Grid>
                <Grid item md={7} className={styles.colDocument}>
                  <div>{report.description}</div>
                </Grid>
                <Grid item md={2} className={`${styles.end}`}>
                  <DownloadButtonV2
                    download={() => report.downloadLink(report)}
                    text={props.t("dealerReporting.download")}
                  />
                </Grid>
              </Grid>
            </React.Fragment>
          )
      )}
    </>
  );
};

export default withTranslation("emp")(DealerReporting);
